/** Build-time flag: responsive temporary drawer + bottom nav below md (default on). */
export function useMobileNav(): boolean {
  const raw = import.meta.env.VITE_MOBILE_NAV
  if (raw === undefined || raw === '') return true
  const normalized = String(raw).trim().toLowerCase()
  if (normalized === 'false' || normalized === '0') return false
  return normalized === 'true' || normalized === '1'
}
